import { css } from "@emotion/react";
import styled from "@emotion/styled";

const AgreementText = styled.p<{ isInvalid: boolean }>`
  font-size: 14px;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;

  a {
    color: var(--primary-color);
    text-decoration: none;
  }

  ${(props) => {
    if (props.isInvalid) {
      return css`
        color: var(--red);

        a {
          color: var(--red);
        }
      `;
    }

    return css``;
  }}
`;

export default AgreementText;
